import React, { useMemo } from 'react';
import { FunctionComponent } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { createBoard, updateBoard } from '../../../../../app/page/page-storage/meeting-boards/meeting-boards.actions';
import { IBoard, IBoardCreateForm } from '../../../../../app/resource/boards/board/board.types';
import { meetingSimpleSelectors } from '../../../../../app/resource/meeting-simple/meeting-simple.selectors';

import { useRequiredValidation } from '../../../../../utils/form/validation.utils';
import { useSelect } from '../../../../../utils/selector.utils';
import { ColorInput } from '../../inputs/ColorInput';
import { SelectInput } from '../../inputs/SelectInput';
import { FormTextInput } from '../../inputs/TextInput';
import { IBoardFormProps } from './types';

export const BoardForm: FunctionComponent<IBoardFormProps> = ({ boardData, meetingId }) => {
  const dispatch = useDispatch();
  const formProps = useForm();

  const requiredValidation = useRequiredValidation();

  const onSubmit = (data: IBoardCreateForm, boardId?: IBoard['id']) => {
    if (boardId && boardData) {
      dispatch(updateBoard(boardId, { ...boardData, ...data }));
    } else {
      dispatch(createBoard({ ...data }));
    }
  };

  const meetings = useSelect(meetingSimpleSelectors.selectResourceList);

  const options = useMemo(
    () =>
      meetings.map((meeting) => ({
        value: meeting.id,
        label: meeting.title,
      })),
    [meetings],
  );

  const meetingsDefaultOptions = useMemo(
    () =>
      boardData
        ? options.filter((option) => boardData.meetingIds.includes(option.value))
        : meetingId
        ? options.filter((option) => meetingId === option.value)
        : undefined,
    [boardData, meetingId, options],
  );

  return (
    <FormProvider {...formProps}>
      <form
        id="board-form"
        className="topic-form"
        onSubmit={formProps.handleSubmit((formData) => onSubmit(formData as IBoardCreateForm, boardData?.id))}
        method="post"
      >
        <div className="field-container">
          <FormTextInput
            id="name"
            name="name"
            type="text"
            label="Board Title"
            placeholder="Enter Title"
            defaultValue={boardData ? boardData.name : ''}
            validation={requiredValidation}
          />
        </div>
        <div className="field-container">
          <SelectInput
            id="meetingIds"
            name="meetingIds"
            label="Meetings"
            placeholder="Search..."
            validation={requiredValidation}
            options={options}
            defaultOptions={meetingsDefaultOptions}
          />
        </div>
        <div className="popup-upload-panel">
          <ColorInput
            id="color"
            name="color"
            placeholder="Board Tab Color"
            validation={requiredValidation}
            defaultValue={boardData?.color}
          />
        </div>
      </form>
    </FormProvider>
  );
};
